import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as LongGoalActions from '../actions/long-goals.actions';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { GoalsService } from 'src/app/shared/services/goals.service';

@Injectable()
export class LongGoalEffects {
  constructor(
    private actions$: Actions,
    private longGoalService: GoalsService
  ) {}

  // Load LongGoals
  loadLongGoals$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LongGoalActions.loadLongGoals),
      mergeMap(() =>
        this.longGoalService.getLongGoals().pipe(
          map(goals => LongGoalActions.loadLongGoalsSuccess({ goals })),
          catchError(error => of(LongGoalActions.loadLongGoalsFailure({ error: error.message })))
        )
      )
    )
  );

  // Create LongGoal
  createLongGoal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LongGoalActions.createLongGoal),
      mergeMap(action =>
        this.longGoalService.createLongGoal(action.goal).pipe(
          map(goal => LongGoalActions.createLongGoalSuccess({ goal })),
          catchError(error => of(LongGoalActions.createLongGoalFailure({ error: error.message })))
        )
      )
    )
  );

  // Update LongGoal
  updateLongGoal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LongGoalActions.updateLongGoal),
      mergeMap(action =>
        this.longGoalService.updateLongGoal(action.goalId, action.goal).pipe(
          map(updatedLongGoal => LongGoalActions.updateLongGoalSuccess({ goal: updatedLongGoal })),
          catchError(error => of(LongGoalActions.updateLongGoalFailure({ error: error.message })))
        )
      )
    )
  );
}
